import { defineMessages } from "react-intl";

export const messages = defineMessages({
    filterAlbums: {
        id: "music.settings.albums-filter",
        defaultMessage: "Filter by album",
    },
    newArtist: {
        id: "music.general.new-artist",
        defaultMessage: "New artist",
    },
    draftAlbum: {
        id: "music.general.draft",
        defaultMessage: "Draft",
    },
    archivedAlbum: {
        id: "music.general.archived",
        defaultMessage: "Archived",
    },
    noAlbumsTitle: {
        id: "music.no-albums-title",
        defaultMessage: "You haven’t created any products yet",
    },
    noAlbums: {
        id: "music.no-albums",
        defaultMessage: "Add a product to get started",
    },
    addAProduct: {
        id: "music.products.add",
        defaultMessage: "Add a product",
    },
    latestAlbums: {
        id: "music.latest-albums",
        defaultMessage: "Latest products created",
    },
    productInformation: {
        id: "music.product-information",
        defaultMessage: "Product information",
    },
    trackInformation: {
        id: "music.track-information",
        defaultMessage: "Track information",
    },
    // Album entity
    albumLinks: {
        id: "music.album.links",
        defaultMessage: "Linkfire and playlists",
    },
    albumLinksDescription: {
        id: "music.album.links-description",
        defaultMessage: `Here you will find the pre-save link to share the release on your socials,
as well as the playlists obtained on Monday after the release, before 1 PM.`,
    },
    albumEntitySingular: {
        id: "music.album.entity_singular",
        defaultMessage: "Product",
    },
    albumEntityPlural: {
        id: "music.album.entity_plural",
        defaultMessage: "Products",
    },
    albumEntityDefiniteArticle: {
        id: "music.album.entity_definite_article",
        defaultMessage: "the product",
    },
    albumEntityDemonstrative: {
        id: "music.album.entity_demonstrative",
        defaultMessage: "this product",
    },
    albumEntityIndefiniteArticle: {
        id: "music.album.entity_indefinite_article",
        defaultMessage: "a product",
    },
    albumColumnTitle: {
        id: "music.album.columns.title",
        defaultMessage: "Title",
    },
    albumColumnTitleVersion: {
        id: "music.album.columns.title_version",
        defaultMessage: "Title version",
    },
    albumColumnUpc: {
        id: "music.album.columns.upc",
        defaultMessage: "UPC/EAN",
    },
    albumColumnCustomId: {
        id: "music.album.columns.custom_id",
        defaultMessage: "Catalog number",
    },
    albumColumnOriginalReleaseDate: {
        id: "music.album.columns.original_release_date",
        defaultMessage: "Original release date",
    },
    albumColumnPreorderDate: {
        id: "music.album.columns.preorder_date",
        defaultMessage: "Pre-order date",
    },
    albumColumnReleaseDate: {
        id: "music.album.columns.release_date",
        defaultMessage: "Release date",
    },
    albumColumnComment: {
        id: "music.album.columns.comment",
        defaultMessage: "Comment",
    },
    albumColumnCommentPrivate: {
        id: "music.album.columns.comment-private",
        defaultMessage: "Private comment",
    },
    albumColumnPreorderPreview: {
        id: "music.album.columns.preorder-preview",
        defaultMessage: " Preview during pre-order period",
    },
    albumColumnGenre: {
        id: "music.album.columns.genre",
        defaultMessage: "Genre",
    },
    albumColumnAdditionalGenre: {
        id: "music.album.columns.additional-genre",
        defaultMessage: "Additional genre",
    },
    albumColumnLabel: {
        id: "music.album.columns.label",
        defaultMessage: "Label",
    },
    albumColumnPrice: {
        id: "music.album.columns.price",
        defaultMessage: "Price",
    },
    albumColumnTrackPrice: {
        id: "music.album.columns.track-price",
        defaultMessage: "Track price",
    },
    albumColumnCreatedAt: {
        id: "music.album.columns.created_at",
        defaultMessage: "Created",
    },
    albumColumnUpdatedAt: {
        id: "music.album.columns.updated_at",
        defaultMessage: "Updated",
    },
    // Track entity
    trackEntitySingular: {
        id: "music.track.entity_singular",
        defaultMessage: "Track",
    },
    trackEntityPlural: {
        id: "music.track.entity_plural",
        defaultMessage: "Tracks",
    },
    trackEntityDefiniteArticle: {
        id: "music.track.entity_definite_article",
        defaultMessage: "the track",
    },
    trackEntityDemonstrative: {
        id: "music.track.entity_demonstrative",
        defaultMessage: "this track",
    },
    trackEntityIndefiniteArticle: {
        id: "music.track.entity_indefinite_article",
        defaultMessage: "a track",
    },
    trackColumnTitle: {
        id: "music.track.columns.title",
        defaultMessage: "Title",
    },
    trackColumnTitleVersion: {
        id: "music.track.columns.title_version",
        defaultMessage: "Title version",
    },
    trackColumnIsrc: {
        id: "music.track.columns.isrc",
        defaultMessage: "ISRC",
    },
    trackColumnDuration: {
        id: "music.track.columns.duration",
        defaultMessage: "Duration",
    },
    trackColumnExplicit: {
        id: "music.track.columns.explicit",
        defaultMessage: "Explicit",
    },
    trackColumnGapless: {
        id: "music.track.columns.gapless",
        defaultMessage: "Gapless",
    },
    trackColumnCopyright: {
        id: "music.track.columns.copyright",
        defaultMessage: "Copyright",
    },
    trackColumnArtists: {
        id: "music.track.columns.artists",
        defaultMessage: "Artist(s)",
    },
    trackColumnAlbums: {
        id: "music.track.columns.albums",
        defaultMessage: "Albums",
    },
    trackColumnCreatedAt: {
        id: "music.track.columns.created_at",
        defaultMessage: "Created",
    },
    trackColumnUpdatedAt: {
        id: "music.track.columns.updated_at",
        defaultMessage: "Updated",
    },
    trackColumnGenre: {
        id: "music.track.columns.genre",
        defaultMessage: "Genre",
    },
    trackColumnLabel: {
        id: "music.track.columns.label",
        defaultMessage: "Label",
    },
    // Artist entity
    artistEntitySingular: {
        id: "music.artist.entity_singular",
        defaultMessage: "Artist",
    },
    artistEntityPlural: {
        id: "music.artist.entity_plural",
        defaultMessage: "Artists",
    },
    artistEntityDefiniteArticle: {
        id: "music.artist.entity_definite_article",
        defaultMessage: "the artist",
    },
    artistEntityDemonstrative: {
        id: "music.artist.entity_demonstrative",
        defaultMessage: "this artist",
    },
    artistEntityIndefiniteArticle: {
        id: "music.artist.entity_indefinite_article",
        defaultMessage: "an artist",
    },
    // AlbumTrack entity
    albumTrackColumnDisc: {
        id: "music.album_track.columns.disc",
        defaultMessage: "Disc",
    },
    albumTrackColumnTrack: {
        id: "music.album_track.columns.track",
        defaultMessage: "Track",
    },
    albumTrackColumnAlbumOnly: {
        id: "music.album_track.columns.album_only",
        defaultMessage: "Album only",
    },
    albumTrackColumnPreorderDate: {
        id: "music.album_track.columns.preorder_date",
        defaultMessage: "Pre-order date",
    },
    albumTrackColumnReleaseDate: {
        id: "music.album_track.columns.release_date",
        defaultMessage: "Release date",
    },
    // Label entity
    labelEntitySingular: {
        id: "music.label.entity_singular",
        defaultMessage: "Label",
    },
    labelEntityPlural: {
        id: "music.label.entity_plural",
        defaultMessage: "Labels",
    },
    labelEntityDefiniteArticle: {
        id: "music.label.entity_definite_article",
        defaultMessage: "the label",
    },
    labelEntityDemonstrative: {
        id: "music.label.entity_demonstrative",
        defaultMessage: "this label",
    },
    labelEntityIndefiniteArticle: {
        id: "music.label.entity_indefinite_article",
        defaultMessage: "an label",
    },
    labelColumnName: {
        id: "music.label.columns.name",
        defaultMessage: "Name",
    },
});
